const imageConfig = {
  engineering: [
    {
      path: `products_new/mattress/tireless_improvement/engineering-crop.jpg`,
      media: `(max-width: 559px)`,
      sizes: `calc(100vw - 1.25rem)`,
      min: 300,
      max: 539,
    },
    {
      path: `products_new/mattress/tireless_improvement/engineering.jpg`,
      media: `(min-width: 560px) and (max-width: 1023px)`,
      sizes: `75vw`,
      min: 420,
      max: 767,
    },
    {
      path: `products_new/mattress/tireless_improvement/engineering-crop.jpg`,
      media: `(min-width: 1024px) and (max-width: 1599px)`,
      sizes: `50vw`,
      min: 512,
      max: 800,
    },
    {
      path: `products_new/mattress/tireless_improvement/engineering.jpg`,
      media: `(min-width: 1600px)`,
      sizes: `800px`,
      min: 800,
    },
  ],
  cool: [
    {
      path: `products_new/mattress/cool_by_design/cool-mobile.jpg`,
      media: `(max-width: 767px)`,
      sizes: `100vw`,
      min: 320,
      max: 767,
    },
    {
      path: `products_new/mattress/cool_by_design/cool-tablet.jpg`,
      media: `(min-width: 768px) and (max-width: 1023px)`,
      sizes: `100vw`,
      min: 768,
      max: 1023,
    },
    {
      path: `products_new/mattress/cool_by_design/cool-desktop.jpg`,
      media: `(min-width: 1024px)`,
      sizes: `(min-width: 1376px) 1100px, 80vw`,
      min: 820,
      max: 1100,
    },
  ],
  lifestyle: [
    {
      path: `products_new/mood/cozy-mobile.jpg`,
      media: `(max-width: 559px)`,
      sizes: `100vw`,
      min: 320,
      max: 559,
    },
    {
      path: `products_new/mood/cozy-tablet.jpg`,
      media: `(min-width: 560px) and (max-width: 1023px)`,
      sizes: `100vw`,
      min: 560,
      max: 1023,
    },
    {
      path: `products_new/mood/cozy-desktop.jpg`,
      media: `(min-width: 1024px)`,
      sizes: `(min-width: 1600px) 1280px, 100vw`,
      min: 1024,
      max: 1600,
    },
  ],
};

export default imageConfig;
